import {Loader} from './submodules/loader/loader';
import {connect} from 'socket.io-client';
import $ from 'jquery';
import {ISocketData} from './interface';
import {App} from '../app/app';
import AppComponent = App.AppComponent;

const AUTO_RENEW_SELECTOR: string = ".gamecloud__header .fancy-checkbox";


export class Gamecloud {

  public gameserverid: any;

  public constructor() {
    this.gameserverid = window.gameserverId;
    if ($('.server__cover').length > 0) {
      $("body")
        .not('[data-page-type="landingpage"]')
        .find('.ref')
        .hide();
    }
  }

  public isBF4(): boolean {
    return AppComponent.getGameKey() === 'bf4';

    // return window.location.href.indexOf('battlefield-4') > 0;
  }

  public isBF3(): boolean {
    return AppComponent.getGameKey() === 'bf3';

    // return window.location.href.indexOf('battlefield-3') > 0;
  }

  public isBFHardline(): boolean {
    return AppComponent.getGameKey() === 'bfHardline';
  }

  public isBF(): boolean {
    return ['bf3', 'bf4', 'bfHardline'].indexOf(AppComponent.getGameKey()) > -1;

    // return window.location.href.indexOf('battlefield') > 0;
  }

  public isSquad(): boolean {
    return AppComponent.getGameKey() === 'squad';
  }

  public isMinecraft(): boolean {
    return AppComponent.getGameKey() === 'minecraft';
  }

  public isValheim(): boolean {
    return AppComponent.getGameKey() === 'valheim';
  }


  /**
   * Global loader instace
   * Usage: show/hide loader
   */
  public loader: Loader = new Loader();
}

if ($("div.gameserverlist").length > 0) {
  console.log("###### gameserverlist exists");
}
if ($("div.gameservertable").length > 0) {
  console.log("###### gameservertable exists");
}

if ($("div.gameserverlist").length > 0 && ("[data-service-id]").length > 0) {
  const socket = connect(window.socketURL + 'sensors',
    {
      path: `/${window.regionPrefix}/ws/legacy/socket.io`,
      reconnectionAttempts: 7,
      reconnectionDelayMax: 7000,
      randomizationFactor: 0.7,
      transports: ['websocket', 'polling'],
    });

  socket.on('connect', () => {
    $("[data-service-id]").each((i, el) => {
      socket.emit('openService', $(el).data("service-id"));
    });
  });

  socket.on('data', (type, id, data: ISocketData) => {
    const event = new CustomEvent('socketData', {detail: {type, id, data}});
    window.dispatchEvent(event);
  });
}
